export default __webpack_public_path__ + "8f31e96cb2adcd0109d32590719b7c07.png";